import React, { useEffect, useState } from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../../table/Table"; // new
import {getAuthorization} from "../../../../axios/AxiosAut";
import { useNavigate } from "react-router-dom";
import {
  setItemsSuppliers,
  SetCurrentID,
} from "../../../../redux/slices/item/itemSlice";
import { useDispatch, useSelector } from "react-redux";

function ItemsSupplierTableData(ID) {
  const dispatch = useDispatch();
  const ItemsSuppliers = useSelector((state) => state.item.ItemsSuppliers);
  const CurrentID = useSelector((state) => state.item.CurrentID);
  const ItemDetails = useSelector((state) => state.item.ItemDetails);

  const getSupplierData = () => {
    getAuthorization()
      .get(`product/get_product_suppliers/${ID.Id}/`)
      .then((res) => {
        console.log("ItemsSuppliers", res.data);
        dispatch(setItemsSuppliers(res.data));
        dispatch(SetCurrentID(ID.Id));
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    console.log("id  Supplier..", ID.id);
    console.log("ItemDetails.id.....", ItemDetails.id);
    console.log("CurrentID.id.....", CurrentID);

    if (ItemsSuppliers.length === 0 || CurrentID !== ItemDetails.id) {
      getSupplierData();
      console.log("API called.....ItemsSuppliers");
      console.log("id  Supplier..", ID.id);

      console.log("ItemsSuppliers.....", ItemsSuppliers);
    }
  }, []);
  const data = ItemsSuppliers;
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Phone Number",
        accessor: "phone_number",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Business Type",
        accessor: "business_type",
      },
    ],
    []
  );

  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-1">
          <Table columns={columns} data={data} text="Suppliers" />
        </div>
      </main>
    </div>
  );
}

export default ItemsSupplierTableData;
